import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

// default empty state
let state = {
    quote: {},
    soldquote: {},
    loading: true,
    token: '',
}

// state from browser local storage
let localstorage_state = JSON.parse( Vue.localStorage.get(process.env.VUE_APP_STORE_KEY) )
if(localstorage_state) {
    Object.keys(localstorage_state).forEach(e => {
            if(localstorage_state[e] && localstorage_state[e] != null) {
                state[e] = localstorage_state[e]
            }
        }
    )
}

export default new Vuex.Store({
    state: state,
    getters: {
        get_loading(state)
        {
            return state.loading
        },
        get_active_quote(state)
        {
            return state.quote
        },
        get_token(state)
        {
            return state.token
        },
    },
    // mutations -> operazioni SINCRONE (triggerate da .commit())
    mutations: {
        set_loading(state,payload)
        {
            state.loading = payload
        },
        set_quote(state,payload)
        {
            state.quote = payload
        },
        set_quote_details(state,payload)
        {
            state.quote.details = payload
        },
        set_soldquote(state,payload)
        {
            state.soldquote = payload
        },
        set_quote_general_info(state,payload)
        {
            state.request_id = payload.request_id
            state.user_id = payload.user_id
            state.created_at = payload.created_at
            state.details = payload.details
        },
        set_quote_grand_total(state,payload)
        {
            state.quote.details.grand_total = payload
        },
        set_service_public_data(state,payload)
        {
            let index = state.quote.services.findIndex(item => item.service_index === payload.service_index)

            state.quote.services[index].public_data = payload.public_data
        },
        set_service_private_data(state,payload)
        {
            let index = state.quote.services.findIndex(item => item.service_index === payload.service_index)

            state.quote.services[index].private_data = payload.private_data
        },
        set_service_supplier_price_details(state,payload)
        {
            let index = state.quote.services.findIndex(item => item.service_index === payload.service_index)

            state.quote.services[index].private_data.supplier_price_details = payload.supplier_price_details
        },
        set_service(state,payload)
        {
            let index = state.quote.services.findIndex(item => item.service_index === payload.service.service_index)

            if(state.quote.services[index] !== undefined)
            {
                state.quote.services[index] = payload.service
            }
            else
            {
                state.quote.services.push(payload.service)
            }
        },
        set_token(state,payload)
        {
            state.token = payload.token
        },
    },
    // actions -> operazioni ASINCRONE che lanciano mutations (triggerate da .dispatch())
    actions: {
        // toggle(context, payload) {
        //     context.commit('toggle', payload);
        // }
        update_quote_grand_total(context)
        {
            let grand_total = 0
            state.quote.services.forEach(service => {
                if(service.public_data.public_price) grand_total += parseFloat(service.public_data.public_price)
            })
            context.commit('set_quote_grand_total', grand_total)
        }
    },
    modules: {
        //otherStoreModule: otherStoreModule
    }
})